import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-accept-schedule',
  templateUrl: './accept-schedule.component.html',
  styleUrls: ['./accept-schedule.component.scss'],
})
export class AcceptScheduleComponent implements OnInit {
  @Input() init: string = '';
  @Input() end: string = '';
  @Input() calendarDate: string = '';

  public msg = '';

  constructor(
    private popoverController: PopoverController,
    private trSv: TranslateService,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    const translate = this.trSv.instant('AGENDAD_CON_EXITO_DESC', {
      date: this.datePipe.transform(this.calendarDate),
      init: this.init,
      end: this.end,
    });
    this.msg = translate;
  }

  schedule() {
    this.popoverController.dismiss();
  }
}
